import { useEffect, useState } from "react";
import { IconController } from "../../../../../Scripts/ImgController";
import assets from "../../../../../../assets/assets";
import styled from "styled-components";
import Person from "../contractType/Person";
import Organization from "../contractType/Organization";
import { useContract } from "../../../../../../provider/ContractProvider";

const Wrapper = styled.div`
  .border-CK {
    border: 1px solid #d1d5db;
    border-radius: 12px;
    position: relative;
    background: white;
    width: 100%;
    z-index: 99;
  }
  .border-bottom {
    border-bottom: 1px solid #e4e7ec;
    padding-bottom: 24px;
  }
  .paragraph-CK {
    color: #344054;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    flex-basis: 30%;
  }
  input {
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    padding: 10px 14px;
    font-size: 14px;
    width: 100%;
  }

  input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: 500;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .input-default {
    border: 1px solid rgba(208, 213, 221, 1);
    border-radius: 8px;
  }
  .input-error {
    border: 1px solid #f44336;
    border-radius: 8px;
  }
  .input-radius {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  .text-input {
    position: relative;
    height: 100%;
  }
`;

const BUTTONS = [
  { label: "Хувь хүн", icon: "fileEdit", activeTab: 0 },
  { label: "Байгууллага", icon: "organization", activeTab: 1 },
];
const PersonalInformation = ({ values, setValues }) => {
  const { data } = useContract();
  const [activeTab, setActiveTab] = useState(data.is_label);

  useEffect(() => {
    if (data.is_label === 0 || data.is_label === 1) {
      setActiveTab(data.is_label);
    }
  }, [data.is_label]);

  return (
    <Wrapper>
      <div>
        <div className="flex items-center gap-4 p-6">
          {BUTTONS.map(({ label, icon, activeTab: tab }) => (
            <label
              key={label}
              className={`border-2 w-full rounded-lg flex items-center gap-2 px-4 py-3 
      ${
        activeTab === tab
          ? "bg-blue-50 border-2 border-mmusic text-mmusic cursor-pointer"
          : "bg-white border border-[#E4E7EC] text-gray-500 opacity-50 cursor-not-allowed"
      }`}
            >
              <div
                className={`p-1 rounded-full ${
                  activeTab === tab ? "bg-gray-100" : "bg-blue-100"
                }`}
              >
                <IconController
                  src={assets.svg[icon] || assets.svg.organization}
                  className="text-mmusic w-5 h-5"
                />
              </div>
              <input
                type="radio"
                name="activeTab"
                checked={activeTab === tab}
                className="hidden"
              />

              <h5>{label}</h5>

              {/* Радио товч */}
              <div className="ml-auto">
                <div
                  className={`w-4 h-4 rounded-full flex items-center justify-center
          ${activeTab === tab ? "bg-mmusic" : "border border-[#E4E7EC]"}
        `}
                >
                  {activeTab === tab && (
                    <div className="w-1.5 h-1.5 bg-white rounded-full" />
                  )}
                </div>
              </div>
            </label>
          ))}
        </div>
        {activeTab === 0 ? (
          <div>
            <Person values={values} setValues={setValues} />
          </div>
        ) : (
          <div>
            <Organization values={values} setValues={setValues} />
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default PersonalInformation;
